import Button from "../../components/Button"
import {IFeatGridFilter, IFeatGridQuery} from "../../helpers/Interfaces";
import * as React from "react";
import {useNavigate} from "react-router-dom";

interface HomeProps {
    filterObj: IFeatGridFilter
    setFilterObj: Function
    // queryObj: IFeatGridQuery
    setQueryObj: Function
    featStaticData: any
}

export default function FeatFilterBlock(props: HomeProps) {

    const {filterObj, setFilterObj, setQueryObj, featStaticData} = props

    function handleChange(value: string, name: string) {

        setFilterObj((prevState: any) => {
            return {...prevState, [name as keyof typeof prevState]: value.trimStart()}
        })
    }

    const navigate = useNavigate()

    function handleClick(event: any) {
        // window.history.replaceState(null, '', `/prj/${queryObj.projID}/feats/1`)

        if (event.target.name === 'Search' || event.key === 'Enter') {
            setQueryObj((prevState: any) => {
                return {...prevState, filterObj: filterObj, currentPage: 1}
            })

            navigate(`../1`)
            localStorage.setItem('filterFeats', JSON.stringify(filterObj))

        } else {
            for (let k in filterObj) {
                if (k !== 'taxType') {
                    filterObj[k as keyof typeof filterObj] = ''
                }
            }
            setQueryObj((prevState: any) => {
                return {...prevState, filterObj: filterObj, currentPage: 1}
            })

            navigate(`../1`)
            localStorage.removeItem("filterFeats")
            // localStorage.setItem('filterFields', JSON.stringify({}));
        }
    }

    let featTypeOptions = null
    if (featStaticData && 'featTypes' in featStaticData) {
        featTypeOptions = featStaticData.featTypes.map((item: any, index: any) => {
            return <option key={index} value={item}>{item}</option> })
    }

    let featStatusOptions = null
    if (featStaticData && 'featClasses' in featStaticData) {
        featStatusOptions = featStaticData.featClasses.map((item: any, index: any) => {
            return <option key={index} value={item}>{item}</option> })
    }


    return (

        <div className="filter-base-container feat-grid-filter">

            <div className="trg-subcont">
                <div className="field-label">Taxonomy type</div>
                <select
                    id="tax_type"
                    name="taxType"
                    className="bold"
                    onChange={(event) => handleChange(event.target.value, event.target.name)}
                    // onKeyDown={(event) => event.key === 'Enter' ? handleClick(event) : ''}
                    value={filterObj.taxType}
                >
                    <option value="target">target</option>
                    <option value="source">source</option>
                </select>
            </div>

            <div className="trg-subcont">
                <div className="field-label">Category ID</div>
                <input
                    id="trg-cat-id"
                    name="catID"
                    type="text"
                    className="filter-input"
                    onChange={(event) => handleChange(event.target.value, event.target.name)}
                    onKeyDown={(event) => event.key === 'Enter' ? handleClick(event) : ''}
                    // value={filterObj.filterCatID}
                    value={filterObj.catID}
                />
            </div>

            <div className="trg-subcont">
                <div className="field-label">Category Name</div>
                <input
                    id="trg-cat-name"
                    name="catName"
                    type="text"
                    className="filter-input"
                    onChange={(event) => handleChange(event.target.value, event.target.name)}
                    onKeyDown={(event) => event.key === 'Enter' ? handleClick(event) : ''}
                    // value={filterObj.filterCatName}
                    value={filterObj.catName}
                />
            </div>

            <div className="trg-subcont">
                <div className="field-label">Feature ID</div>
                <input
                    id="trg-feat-id"
                    name="featID"
                    type="text"
                    className="filter-input"
                    onChange={(event) => handleChange(event.target.value, event.target.name)}
                    onKeyDown={(event) => event.key === 'Enter' ? handleClick(event) : ''}
                    value={filterObj.featID}
                />
            </div>

            <div className="trg-subcont">
                <div className="field-label">Feature Name</div>
                <input
                    id="trg-feat-name"
                    name="featName"
                    type="text"
                    className="filter-input"
                    onChange={(event) => handleChange(event.target.value, event.target.name)}
                    onKeyDown={(event) => event.key === 'Enter' ? handleClick(event) : ''}
                    // value={filterObj.filterFeatName}
                    value={filterObj.featName}
                />
            </div>

            <div className="trg-subcont">
                <div className="field-label">Feature Type</div>
                <select
                    name="featType"
                    onChange={(event) => handleChange(event.target.value, event.target.name)}
                    value={filterObj.featType}
                >
                    <option key={-1} value=''></option>
                    {featTypeOptions}
                </select>
            </div>

            <div className="trg-subcont">
                <div className="field-label">Feature Class</div>
                <select
                    name="featStatus"
                    onChange={(event) => handleChange(event.target.value, event.target.name)}
                    onKeyDown={(event) => event.key === 'Enter' ? handleClick(event) : ''}
                    value={filterObj.featStatus}
                >
                    <option key={-1} value=''></option>
                    {featStatusOptions}
                </select>
            </div>

            <div className="trg-subcont">
                <div className="field-label">Mapping Status</div>
                <select
                    name="mapStatus"
                    onChange={(event) => handleChange(event.target.value, event.target.name)}
                    onKeyDown={(event) => event.key === 'Enter' ? handleClick(event) : ''}
                    value={filterObj.mapStatus}
                >
                    <option value=""></option>
                    <option value="mapped">mapped</option>
                    {filterObj.taxType == 'target' && <option value="is_default">is_default</option>}
                    <option value="not mapped">not mapped</option>
                    {filterObj.taxType == 'source' && <option value="parked">parked</option>}
                    {/*<option value="parked">parked</option>*/}
                </select>
            </div>


            <div className="btn-container">
                {/*<Button type="primary" text="Search" onclick={handleClick}/>*/}
                <Button type="primary" text="Search" onclick={(event:any) => handleClick(event)} />
            </div>

            <div className="btn-container">
                <Button type="secondary" text="Clear" onclick={(event:any) => handleClick(event)} />
            </div>

        </div>
    )
}
